import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function BenefitsSection() {
  const benefits = ['Multiplicar tus plantas favoritas sin gastar en viveros', 'Saber exactamente qué hacer en cada etapa (sin improvisar)', 'Evitar los errores que matan el 80% de los esquejes', 'Tener plantas nuevas en 4-8 semanas (según la especie)', 'Aplicar el método a cualquier planta de tu casa o jardín', 'Dejar de perder tiempo buscando videos sueltos en internet'];
  return <section className="py-16 md:py-24 bg-white" data-id="element-1">
      <div className="max-w-4xl mx-auto px-4 sm:px-6" data-id="element-2">
        <div className="text-center mb-12" data-id="element-3">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1a1a1a] mb-4" data-id="element-4">
            Qué vas a lograr con esta guía
          </h2>
          <p className="text-lg text-[#666666]" data-id="element-5">
            Resultados concretos que vas a ver en las próximas semanas
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-6">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-start gap-4 p-6 bg-[#fafaf9] rounded-2xl border border-gray-100 hover:border-[#4a7c2c] transition-colors" data-id="element-7">
              <div className="bg-[#4a7c2c] rounded-full p-1 shrink-0 mt-1" data-id="element-8">
                <Check className="w-4 h-4 text-white" data-id="element-9" />
              </div>
              <p className="text-lg text-[#1a1a1a] font-medium" data-id="element-10">{benefit}</p>
            </motion.div>)}
        </div>

        <div className="mt-16 bg-[#f1f8e9] rounded-3xl p-8 md:p-12" data-id="element-11">
          <h3 className="text-2xl font-bold text-[#1a1a1a] mb-8 text-center" data-id="element-12">
            Lo que dicen quienes ya la tienen
          </h3>
          <div className="grid md:grid-cols-3 gap-6" data-id="element-13">
            <div className="bg-white p-6 rounded-xl shadow-sm" data-id="element-14">
              <p className="text-[#666666] mb-4 italic" data-id="element-15">
                "Finalmente entendí por qué mis esquejes no prosperaban. Ahora
                tengo plantas para regalar."
              </p>
              <p className="text-sm font-bold text-[#4a7c2c]" data-id="element-16">
                — Martín, Córdoba
              </p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-sm" data-id="element-17">
              <p className="text-[#666666] mb-4 italic" data-id="element-18">
                "Pensé que era difícil, pero la guía lo hace súper simple. Hasta
                mi mamá lo está usando."
              </p>
              <p className="text-sm font-bold text-[#4a7c2c]" data-id="element-19">
                — Lucía, Rosario
              </p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-sm" data-id="element-20">
              <p className="text-[#666666] mb-4 italic" data-id="element-21">
                "Dejé de perder tiempo buscando en YouTube. Acá está todo lo que
                necesito."
              </p>
              <p className="text-sm font-bold text-[#4a7c2c]" data-id="element-22">
                — Diego, Mendoza
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}